import { useCallback, useState } from 'react';
import { GetAdminOnboardingSimulationAPI } from '../../../../api/AdminAPI';

/**
 * useOnboardingSimulation
 *
 * Quem recebe o quê nos próximos 7, 14 ou 30 dias, sem gravar nada. Com "todos ligados",
 * mostra o efeito antes de ligar os modelos.
 */
function useOnboardingSimulation() {
  const [state, setState] = useState({ loading: false, error: null, result: null });

  const simulate = useCallback((assumeAllEnabled, days) => {
    setState((prev) => ({ ...prev, loading: true, error: null }));
    GetAdminOnboardingSimulationAPI(assumeAllEnabled, days, (response) => {
      if (!response || response.success === false) {
        setState({ loading: false, error: response?.error || 'Não foi possível montar a simulação.', result: null });
        return;
      }
      setState({ loading: false, error: null, result: response });
    });
  }, []);

  return { ...state, simulate };
}

export default useOnboardingSimulation;
